module.exports = __webpack_public_path__ + "static/customize3-dc8e3c8ad509df38893a496f7bbf9330.png";